// Wallet/trustline readiness check — replaces the legacy
// GET /api/account/wallet-status?offering_id=... with a POST that takes
// the offering id in the body. Backed by the crypto-wallet controller.
export const WALLET_ENDPOINTS = {
  OFFERING_READINESS: '/api/wallets/crypto/offering-readiness-checks',
} as const
